// @generated by protoc-gen-connect-es v1.4.0 with parameter "target=ts"
// @generated from file web/public/user.proto (package web.public, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { DismissRequest, DismissResponse, GetAddressChangeStatusResponse, GetAddressCorrectionRequest, GetAddressCorrectionResponse, GetCreditMonitoringAlertsRequest, GetCreditMonitoringAlertsResponse, GetInitPageRequest, GetInitPageResponse, GetInquiryIdRequest, GetPersonaAddressVerificationLinkResponse, GetPersonaInquiryStatusResponse, GetPhoneCodeV2Request, GetPhoneCodeV2Response, GetPhoneValidationV2Request, GetPhoneValidationV2Response, GetSiteVarsRequest, GetSiteVarsResponse, GetUserInfoRequest, GetUserInfoResponse, ResendConfirmationEmailRequest, ResendConfirmationEmailResponse, ReVerifyIdentityRequest, ReVerifyIdentityResponse, TriggerBrazeEventRequest, TriggerBrazeEventResponse, UpdateAccountAddressRequest, UpdateAccountAddressResponse, UpdateAccountEmailRequest, UpdateAccountEmailResponse, UpdateAccountNameRequest, UpdateAccountNameResponse, UpdateLocaleRequest, UpdateLocaleResponse, UpdateNotificationChannelsRequest, UpdateNotificationChannelsResponse, UpdatePasswordRequest, UpdatePasswordResponse, UpdatePhoneV2Request, UpdatePhoneV2Response, UpdateShippingAddressRequest, UpdateShippingAddressResponse, UpdateThemeRequest, UpdateThemeResponse } from "./user_pb.js";
import { Empty, MethodKind } from "@bufbuild/protobuf";

/**
 * @generated from service web.public.Account
 */
export const Account = {
  typeName: "web.public.Account",
  methods: {
    /**
     * @generated from rpc web.public.Account.GetUserInfo
     */
    getUserInfo: {
      name: "GetUserInfo",
      I: GetUserInfoRequest,
      O: GetUserInfoResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc web.public.Account.UpdatePassword
     */
    updatePassword: {
      name: "UpdatePassword",
      I: UpdatePasswordRequest,
      O: UpdatePasswordResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc web.public.Account.UpdateEmail
     */
    updateEmail: {
      name: "UpdateEmail",
      I: UpdateAccountEmailRequest,
      O: UpdateAccountEmailResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc web.public.Account.UpdateNotificationChannels
     */
    updateNotificationChannels: {
      name: "UpdateNotificationChannels",
      I: UpdateNotificationChannelsRequest,
      O: UpdateNotificationChannelsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc web.public.Account.UpdateAddress
     */
    updateAddress: {
      name: "UpdateAddress",
      I: UpdateAccountAddressRequest,
      O: UpdateAccountAddressResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc web.public.Account.UpdateShippingAddress
     */
    updateShippingAddress: {
      name: "UpdateShippingAddress",
      I: UpdateShippingAddressRequest,
      O: UpdateShippingAddressResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc web.public.Account.UpdateName
     */
    updateName: {
      name: "UpdateName",
      I: UpdateAccountNameRequest,
      O: UpdateAccountNameResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc web.public.Account.GetAddressCorrection
     */
    getAddressCorrection: {
      name: "GetAddressCorrection",
      I: GetAddressCorrectionRequest,
      O: GetAddressCorrectionResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc web.public.Account.UpdateLocale
     */
    updateLocale: {
      name: "UpdateLocale",
      I: UpdateLocaleRequest,
      O: UpdateLocaleResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc web.public.Account.UpdateTheme
     */
    updateTheme: {
      name: "UpdateTheme",
      I: UpdateThemeRequest,
      O: UpdateThemeResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc web.public.Account.GetCreditMonitoringAlerts
     */
    getCreditMonitoringAlerts: {
      name: "GetCreditMonitoringAlerts",
      I: GetCreditMonitoringAlertsRequest,
      O: GetCreditMonitoringAlertsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc web.public.Account.GetPhoneValidationV2
     */
    getPhoneValidationV2: {
      name: "GetPhoneValidationV2",
      I: GetPhoneValidationV2Request,
      O: GetPhoneValidationV2Response,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc web.public.Account.GetPhoneCodeV2
     */
    getPhoneCodeV2: {
      name: "GetPhoneCodeV2",
      I: GetPhoneCodeV2Request,
      O: GetPhoneCodeV2Response,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc web.public.Account.UpdatePhoneV2
     */
    updatePhoneV2: {
      name: "UpdatePhoneV2",
      I: UpdatePhoneV2Request,
      O: UpdatePhoneV2Response,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc web.public.Account.GetSiteVars
     */
    getSiteVars: {
      name: "GetSiteVars",
      I: GetSiteVarsRequest,
      O: GetSiteVarsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc web.public.Account.GetInitPage
     */
    getInitPage: {
      name: "GetInitPage",
      I: GetInitPageRequest,
      O: GetInitPageResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc web.public.Account.Dismiss
     */
    dismiss: {
      name: "Dismiss",
      I: DismissRequest,
      O: DismissResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc web.public.Account.TriggerBrazeEvent
     */
    triggerBrazeEvent: {
      name: "TriggerBrazeEvent",
      I: TriggerBrazeEventRequest,
      O: TriggerBrazeEventResponse,
      kind: MethodKind.Unary,
    },
    /**
     * endpoint for resending confirmation email for a given user.
     *
     * @generated from rpc web.public.Account.ResendConfirmationEmail
     */
    resendConfirmationEmail: {
      name: "ResendConfirmationEmail",
      I: ResendConfirmationEmailRequest,
      O: ResendConfirmationEmailResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc web.public.Account.ReVerifyIdentity
     */
    reVerifyIdentity: {
      name: "ReVerifyIdentity",
      I: ReVerifyIdentityRequest,
      O: ReVerifyIdentityResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Checks the user's latest address change request status
     *
     * @generated from rpc web.public.Account.GetAddressChangeStatus
     */
    getAddressChangeStatus: {
      name: "GetAddressChangeStatus",
      I: Empty,
      O: GetAddressChangeStatusResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc web.public.Account.GetPersonaAddressVerificationLink
     */
    getPersonaAddressVerificationLink: {
      name: "GetPersonaAddressVerificationLink",
      I: Empty,
      O: GetPersonaAddressVerificationLinkResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc web.public.Account.GetPersonaInquiryStatus
     */
    getPersonaInquiryStatus: {
      name: "GetPersonaInquiryStatus",
      I: GetInquiryIdRequest,
      O: GetPersonaInquiryStatusResponse,
      kind: MethodKind.Unary,
    },
  }
} as const;

